import React from 'react';
import PropTypes from 'prop-types';
import {Button, List, Tag} from 'antd';
import Toggle from '@web/components/Toggle';
import {DownArrowOutlined} from '@web/assets/icons';
import UserAvatar from '@web/components/UserAvatar';
import Icon from '@web/components/Icon';
import ActionRunListItem from '@web/components/ActionRunListItem';
import ContentData from '@web/ui/containers/ContentData';
import WorkflowServicesListItem from './WorkflowServicesListItem';
import AppStoreItemData from '@web/ui/containers/AppStoreItemData';
import {useSelector} from 'react-redux';

WorkflowServicesList.propTypes = {
  list: PropTypes.array,
  onSelect: PropTypes.func,
  // transformer: PropTypes.func
};

function WorkflowServicesList(props) {
  // const table = useSelector((state) => console.log(">>>", state.Collections?.["app-store"]));
  const appToServiceMapper = React.useCallback((integration) => {
    return {
      type: "integration",
      method: `use:${integration.name ?? integration.appName}`,
      label: (integration.name ?? integration.appName).replace(/[^a-zA-Z0-9]+/g, " "),
      description: "Utilize and manage provided third-party integration", // integration.description,
      agentId: "ai-workflow-integration-action-manager",
      icon: integration.icon || "GlobeIcon",
      logo: integration.logo,
      useContext: true,
      updateContext: true,
      modelPerformance: "model:standard",
      authOptions: integration
        ?.["auth_schemes"]?.map?.((scheme) =>
        scheme?.mode &&
        ({method: scheme?.mode, provider: "composio"}))
      .filter(Boolean),
      contextTemplate: [
        `<Service>`,
        `<Goal>Perform the request using {{service.label}} integration</Goal>`,
        `<Description>{{service?.description}}</Description>`,
        `<Type>{{service?.type}}</Type>`,
        `<Method>{{service?.method}}</Method>`,
        `<Integration id="${integration.appId}">${integration.description}</Integration>`,
        `<Context>{{(context && !!service.useContext) ? JSON.stringify(context) : ""}}</Context>`,
        '<OutOfScope>Your role is strictly scoped to using the integration as requested. Anything additional is out of scope and strictly forbidden unless discussing the request with the user</OutOfScope>',
        '<SuccessCriteria>You are successful when you execute useExternalIntegrationAgent to perform requests on ${label} and complete the request</SuccessCriteria>',
        `</Service>`,
      ],
      actionNames: [
        "useIntegrationAgent",
        'saveSessionResult',
        'throwError',
      ],
    };
  }, []);

  // console.log("WorkflowServicesList props.list", {list: props.list, items: props.items});

  return <List
    dataSource={props.list}
    renderItem={(item) => {
      // console.log("WorkflowServicesList props.list", item);
      return item.method ?
        <WorkflowServicesListItem
          service={item}
          onSelect={props.onSelect}
        /> :
        <AppStoreItemData
          path={item}
          component={WorkflowServicesListItem}
          dataField="service"
          transformer={appToServiceMapper}
        />
    }}
  />
}

export default WorkflowServicesList;
